<template>
    <div class="is-typing-animation" :id="bubbleId">
        <img src="/img/is-typing-animation.gif" alt="is typing">
    </div>
</template>

<script>
import { scrollToLastMessage } from '@helpers/helpers';

export default {
    data() {
        return {
            bubbleId: 'is-typing-bubble',
        };
    },
    mounted() {
        setTimeout(
            this.scrollToLastMessage(
                document.getElementById(this.bubbleId),
                document.querySelector('.js-scroller'),
            ),
            300,
        );
    },
    methods: {
        scrollToLastMessage,
    },
};
</script>
